import React from "react";
import { createBrowserRouter } from "react-router-dom";
import UserValidationRoutes from "./user-validation-router";
import PractitionerModule from "@modules/practitioner/practitioner-module";
import PractitionerRoutes from "./practitioner-router";
import NotFound from "@components/not-found/not-found";

const LandingComponent = React.lazy(
    () => import("@modules/landing/landing-professional/landing-professional")
);
const LoginComponent = React.lazy(() => import("@modules/login/login/login"));
const HelpComponent = React.lazy(() => import("@modules/login/help/help"));
const ResendLinkComponent = React.lazy(
    () => import("@modules/login/help/resend-code/resend-link")
);
const RecoverPasswordComponent = React.lazy(
    () => import("@modules/authentication/recover-password/recover-password")
);
const ChangePasswordComponent = React.lazy(
    () =>
        import(
            "@modules/authentication/recover-password/recover-password-success"
        )
);
const SubscriptionWelcomeComponent = React.lazy(
    () => import("@modules/authentication/subscription/subscription-welcome")
);
const SignInCallbackComponent = React.lazy(
    () => import("@modules/authentication/callback/signinCallback")
);
const StripeLinkAccountCallback = React.lazy(
    () => import("@modules/authentication/callback/stripeLinkAccountCallback")
);
const SignInSilentCallbackComponent = React.lazy(
    () => import("@modules/authentication/callback/signinSilentCallback")
);
const JoinVideoCallGroup = React.lazy(
    () => import("../components/joinVideoCallGroup/joinVideoCallGroup")
);

const SubscriptionCompletedComponent = React.lazy(
    () =>
        import("../components/payment/subscription/subscription-complete-flow")
);
const SubscriptionFreeTrialComponent = React.lazy(
    () => import("../components/payment/subscription/subscription-free-trial")
);
const InitialQuizComponent = React.lazy(
    () => import("@modules/sign-up/initial-quiz/initial-quiz")
);
const SignUpComponent = React.lazy(
    () => import("@modules/sign-up/sign-up/sign-up")
);
const InitialQuizSuccess = React.lazy(
    () => import("@modules/sign-up/initial-quiz/initial-quiz-success")
);

const router = createBrowserRouter([
    { path: "/", Component: LandingComponent },
    { path: "/login", Component: LoginComponent },
    { path: "/help", Component: HelpComponent },
    { path: "/recover-password", Component: RecoverPasswordComponent },
    { path: "/recover-success", Component: ChangePasswordComponent },
    { path: "/resend-link", Component: ResendLinkComponent },
    { path: "/join", Component: JoinVideoCallGroup },
    { path: "/signin-callback", Component: SignInCallbackComponent },
    { path: "/stripe-link-callback", Component: StripeLinkAccountCallback },
    { path: "/subscription", Component: SubscriptionWelcomeComponent },
    { path: "/subscription-completed", Component: SubscriptionCompletedComponent, },
    { path: "/subscription-trial", Component: SubscriptionFreeTrialComponent },
    { path: "/signin-silent-callback", Component: SignInSilentCallbackComponent, },
    { path: "/sign-up", Component: SignUpComponent, },
    { path: "/initial-quiz", Component: InitialQuizComponent, },
    // TODO: Move to signup routes
    { path: "/sign-up/success", Component: InitialQuizSuccess, },
    { 
        path: "/verify/*",
        // element: <></>,
        children: [
            { path: "*", Component: UserValidationRoutes }
        ]
    },
    { 
        path: "/practitioner/*",
        element: <PractitionerModule />,
        children: [
            { path: "*", Component: PractitionerRoutes }
        ]
    },
    { path: "*", element: <NotFound /> },
]);

export default router;
